import styled from 'styled-components';

export const Container = styled.div`
  .hefesto-modal__container {
    padding-bottom: 1.5rem;
  }
`;

export const Form = styled.form`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .hefesto-input-wrapper--neutral .hefesto-input-wrapper__label-wrapper {
    color: inherit;
  }
`;

export const SelectContent = styled.div`
  width: 100%;
  /* max-width: 250px; */
`;

export const AddUserModalContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
  }
`;
